import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import {
  DOCUMENT_DETAILS_GET,
  DOCUMENT_DETAILS_RESET,
} from '../../redux/actions/documents';
import { Container } from '../../../ui/gridSystem';
import { HtmlRaw, Text } from '../../../ui/atoms';
import {
  CardsGrid,
  CategoriesWrapper,
  CategoryLabel,
  Cover,
  FileImg,
  MaterialCard,
  MaterialWrapper,
  RelatedWrapper,
} from './style';
import { getIconByExtension } from '../../../utils/fileExtension';
import { downloadResource } from '../../../utils/fileDownload';
import Icon from '../../../ui/atoms/Icon';
import routes from '../../../routes';
import CardDocuments from '../../../ui/atoms/Cards/CardDocuments';
import theme from '../../../ui/theme';
import { formatFileSize } from '../../../utils/formatFileSize';
import { getUrlWithToken } from '../../../utils/common';
import { useHighlightText } from '../../../utils/highlight';

const DocumentDetails = ({ data, getDocumentDetails, resetDocument }) => {
  const { document_id } = useParams();
  const navigate = useNavigate();
  const [file, setFile] = useState();

  useEffect(() => {
    window.scrollTo(0, 0);
    getDocumentDetails(document_id);

    return () => resetDocument();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [document_id]);

  useEffect(() => {
    if (data?.file) setFile(data.file);
  }, [data]);

  return (
    <div style={{ position: 'relative' }}>
      {data?.cover && <Cover src={data?.cover} />}
      <Container>
        {data?.tags?.length > 0 && (
          <CategoriesWrapper>
            {data.tags.map((c) => (
              <CategoryLabel key={`category-${c?.id}`}>{c?.name}</CategoryLabel>
            ))}
          </CategoriesWrapper>
        )}
        <Text type="h1" mb={16}>
          <HtmlRaw html={useHighlightText(data?.title)} />
        </Text>
        <Text type="b3">
          <HtmlRaw
            html={useHighlightText(data?.description)}
            style={{ textAlign: 'justify' }}
          />
        </Text>
        <MaterialWrapper>
          <div className="title">
            <Text type="h2">I documenti scaricabili</Text>
          </div>
          <div className="cards-wrapper">
            <MaterialCard>
              <FileImg src={getIconByExtension(file?.extension)} />
              <a
                href={getUrlWithToken(file?.url) || ''}
                target="_blank"
                rel="noopener noreferrer"
                className="name"
              >
                {file?.filename}
              </a>
              <p>{formatFileSize(file?.size)}</p>
              <div
                onClick={() =>
                  downloadResource(getUrlWithToken(file?.url), file?.filename)
                }
              >
                <Icon
                  type="download-01"
                  size={25}
                  fill="none"
                  stroke={theme().colors.link}
                />
              </div>
            </MaterialCard>
          </div>
        </MaterialWrapper>
      </Container>
      {data?.related_documents?.length > 0 && (
        <RelatedWrapper>
          <Container>
            <Text type="h2">Documenti correlati</Text>
            <CardsGrid>
              {data.related_documents.map((item, i) => (
                <CardDocuments
                  key={`document-${item?.id}`}
                  item={item}
                  onClick={() =>
                    navigate(`${routes.documentDetails.path}/${item.id}`)
                  }
                  handleGetDocuments={() => getDocumentDetails(document_id)}
                />
              ))}
            </CardsGrid>
          </Container>
        </RelatedWrapper>
      )}
    </div>
  );
};

DocumentDetails.propTypes = {
  data: PropTypes.object,
  getDocumentDetails: PropTypes.func,
  resetDocument: PropTypes.func,
};

export default connect(
  (state) => {
    const { details: data } = state.documents;
    return {
      data,
    };
  },
  (dispatch) => ({
    getDocumentDetails: (id) =>
      dispatch({ type: DOCUMENT_DETAILS_GET._REQUEST, id }),
    resetDocument: () => dispatch({ type: DOCUMENT_DETAILS_RESET }),
  })
)(DocumentDetails);
